import * as pako from 'pako';
import { Base64 } from 'js-base64';

const compressionUtils = {
  base64Encode(str: any): string {
    return btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
      })
    );
  },

  base64Decode(str: any): string {
    if (!Base64.isValid(str)) {
      return str;
    }
    return decodeURIComponent(
      Array.prototype.map
        .call(atob(str), function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
  },

  /**
   * Takes any object and converts to a compressed base64 encoded stream using Gzip algorithm.
   * @param str The object to compress. eg. a string "hello world!" or any object or array.
   */
  compress(str: any): string {
    const string2 = JSON.stringify(str);
    const encoded = pako.gzip(string2);
    const finalResult = btoa(new Uint8Array(encoded).reduce((data, byte) => data + String.fromCharCode(byte), ''));
    return finalResult;
  },

  /**
   *
   * Opposite of compress above.
   * @param str The base64 encoded compressed string eg. "H4sIAAAAAAAAA1PKSM3JyVcozy/KSVFUAgB+hKfGDgAAAA==" => 'hello world!'
   * @returns The unzipped string.
   */
  decompress(str: any): string {
    if (!Base64.isValid(str)) {
      return str;
    }
    const compressData = atob(str);
    const compressData2 = compressData.split('').map(function (e) {
      return e.charCodeAt(0);
    });
    const originalText = pako.ungzip(compressData2, { to: 'string' });
    return JSON.parse(originalText);
  },
};

export { compressionUtils };
